import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createWarranty(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/warranties', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    checkWarranty(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/warranties/check', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}